import React from 'react';
import { faGears } from '@fortawesome/free-solid-svg-icons';

import Icon from './Icon';

const GearsIcon = ({toolTipText = 'Processing'}) => (
  <Icon tooltip={toolTipText} iconObj={faGears} />
);

export default GearsIcon;